import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { Command } from '../../../../common/params/interfaces/command.interface';


import { QSNotificationsService, NotificationProgrammingContext } from '../../services/notifications.service';
import { Agent } from '../../services/interfaces/agent.interface';
import { ProgrammingUtilsService as Utils } from '../../../../common/services/utils.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  templateUrl: './command.component.html',
  styleUrls: ['./command.component.less']
})
export class QSNotificationsCommandComponent {

  private _commands: Observable<Command[]>;
  private _agent: Observable<Agent>;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _notifications: QSNotificationsService,
    private _store: Store<{ notificationsProgramming: NotificationProgrammingContext }>
  ) {
    this._commands = this._store.select(s => s.notificationsProgramming.commands)
      // .map(commands => commands.filter(c => {
      //   return c.params.some(p => p.values.length > 0)
      // }))
      ;

    this._agent = this._store.select(s => s.notificationsProgramming.agent);
  }

  ngOnInit() {
    this._commands.distinctUntilChanged(Utils.distinct).subscribe((commands: Command[]) => {
      if (commands.length === 1) {
        this._router.navigate(['../parameters', commands[0].command, { id: commands[0].id }], { relativeTo: this._route });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-notifications/action/command/command.component.ts